import { CredentialTypeEnum } from 'src/graphql/schema';

import { type IAdditionalFieldType } from './types';

export const otherOptionFields: { label: string; value: IAdditionalFieldType; separator?: boolean }[] = [
  {
    label: 'Text',
    value: 'text',
  },
  {
    label: 'URL',
    value: 'url',
  },
  {
    label: 'Email',
    value: 'email',
  },
  {
    label: 'Date',
    value: 'date',
  },
  {
    label: 'Password',
    value: 'password',
  },
  {
    label: 'Phone',
    value: 'phone',
    separator: true,
  },
  {
    label: 'Note',
    value: 'note',
  },
];

export const secretTypeOptions = [
  {
    label: 'Bearer token',
    value: 'bearer_token',
  },
  {
    label: 'JSON web token',
    value: 'jwt',
  },
  {
    label: 'JSON credentials',
    value: 'json_credentials',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const credentialTypeOptions = [
  {
    label: 'API Credential',
    value: CredentialTypeEnum.ApiCredentials,
  },
  {
    label: 'Login',
    value: CredentialTypeEnum.Login,
  },
  {
    label: 'Cryptographic Key',
    value: CredentialTypeEnum.CryptographicKey,
  },
];

export const credentialTypeOptionsMap = {
  [CredentialTypeEnum.ApiCredentials]: 'API Credential',
  [CredentialTypeEnum.Login]: 'Login',
  [CredentialTypeEnum.CryptographicKey]: 'Cryptographic Key',
};
